import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./css/SectionConsultation.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image from "../../assets/wheat.png";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const SectionConsultation: FunctionComponent = () => {
  const language = useSelector((state: any) => state.language.value);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.zakazati}>
        <div className={styles.flexThis}>
          <div className={styles.spiritLiberContainer}>
            <span className={styles.spiritLiber1}>
              {language === "RO" && "Fă primul pas spre libertate"}
              {language === "EN" && "Make your first step towards freedom"}
            </span>
          </div>
        </div>
        <span className={styles.authorInfo}>
          {language === "EN" && (
            <>
              Do you want to understand yourself more deeply and find inner
              balance? My counseling will help you find new paths to harmony and
              self-confidence.
            </>
          )}
          {language === "RO" && (
            <>
              Doriți să vă înțelegeți mai profund și să găsiți echilibrul
              interior? Consilierea mea vă va ajuta să găsiți noi căi către
              armonie și încredere în sine.
            </>
          )}{" "}
        </span>

        <div className={styles.buyContainer}>
          <Link to="/consultation" className={styles.frame2}>
            <span className={styles.orderBook}>
              {language === "EN" && `Make an appointment for a consultation`}
              {language === "RO" && `Faceți o programare pentru o consultație`}
            </span>
          </Link>
        </div>
      </div>
      <div className={styles.carousel}>
        <img src={image} />
      </div>
    </div>
  );
};

export default SectionConsultation;
